export const Base = class {
};
//# sourceMappingURL=class.js.map